import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  ViewEncapsulation,
} from "@angular/core";

import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

import { CoreMenuService } from "@core/components/core-menu/core-menu.service";
import { AuthenticationService } from "@common/services";

@Component({
    selector: "[core-menu]",
    templateUrl: "./core-menu.component.html",
    styleUrls: ["./core-menu.component.scss"],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CoreMenuComponent implements OnInit {
  currentUser: any;

  @Input()
  layout = "vertical";

  @Input()
  menu: any;

  // Private
  private _unsubscribeAll: Subject<any>;

  /**
   *
   * @param {ChangeDetectorRef} _changeDetectorRef
   * @param {CoreMenuService} _coreMenuService
   */
  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    private _coreMenuService: CoreMenuService,
    private _authenticationService: AuthenticationService
  ) {
    // Set the private defaults
    this._unsubscribeAll = new Subject();
  }

  // Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // Set the menu either from the input or from the service
    this.menu = this.menu || this._coreMenuService.getCurrentMenu();

    // Subscribe to the current user
    this._authenticationService.onUserValueChanged
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((resp) => {
        if (resp) {
          this.currentUser = resp;
          this._changeDetectorRef.markForCheck();

          // Subscribe to the current menu changes
          this._coreMenuService.onMenuChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(() => {
              // Load menu
              this.menu = this._coreMenuService.getCurrentMenu();

              this._changeDetectorRef.markForCheck();
            });
        }
      });
  }
}
